import React from "react"

const Head = () => {
  return (
    <>
      <section className='head'>
        <div className='container d_flex'>
          <div className='left row'>
            <i className='fa fa-phone'></i>
            <label> +880 1627392810</label>
            <i className='fa fa-envelope'></i>
            <label> md.jony.soft@gmail.com</label>
          </div>
          <div className='right row RText'>
           
          
            <label></label>
          </div>
        </div>
      </section>
    </>
  )
}

export default Head
